import type { BlockStatus } from "../../api/types";

// localToday is the viewer's calendar date as YYYY-MM-DD. It reads local date
// parts because toISOString() gives the UTC date, which is a different day for
// part of every day anywhere outside UTC.
export function localToday(now: Date = new Date()): string {
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

// Due dates are YYYY-MM-DD strings, so string order is calendar order and the
// comparison needs no Date parsing at all.
export function isOverdue(dueDate: string | null, status: BlockStatus, today: string = localToday()): boolean {
  return dueDate !== null && status !== "complete" && dueDate < today;
}

// dueDateLabel renders a due date for display. The Date is built from its parts
// in local time: new Date("YYYY-MM-DD") parses as UTC midnight and would show
// the previous day west of UTC.
export function dueDateLabel(dueDate: string | null): string {
  if (dueDate === null) {
    return "No due date";
  }
  const [year, month, day] = dueDate.split("-").map(Number);
  // setFullYear, because the Date constructor maps years 0–99 to 1900–1999.
  const date = new Date(0, 0, 1);
  date.setFullYear(year, month - 1, day);
  return `Due ${date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}`;
}
